import React, {
  useState, useEffect, useContext, createContext,
} from 'react';
// context === redux sama-sama state management
export const Hooks = createContext();
function Index(props) {
  const [modal, setModal] = useState(false);
  const [modalAssessment, setModalAssessment] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalDeleteMember, setModalDeleteMember] = useState(false);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalImport, setModalImport] = useState(false);
  const [modalPrivate, setModalPrivate] = useState(false);
  const [sideBar, setSideBar] = useState(false);
  const [boardNow, setBoardNow] = useState(false);
  const [keywordBoard, setKeywordBoard] = useState(undefined);
  const [filterState, setFilterState] = useState({});
  const [text, setText] = useState({});
  const [boardSw, setBoardSw] = useState('');

  const [datasOkr, setDatasOkr] = useState({});
  const [okrId, setOkrId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showInfoComp, setShowInfoComp] = useState(false);
  const [showInquiryComp, setShowInquiryComp] = useState(false);
  const [dataInfoComp, setDataInfoComp] = useState(false);
  const [isDetailJobDesc, setIsDetailJobDesc] = useState(false);
  const valx = {
    modalAssessment,
    setModalAssessment,
    modal,
    setModal,
    modalDelete,
    setModalDelete,
    modalDeleteMember,
    setModalDeleteMember,
    modalAdd,
    setModalAdd,
    modalPrivate,
    setModalPrivate,
    boardNow,
    setBoardNow,
    sideBar,
    setSideBar,
    keywordBoard,
    setKeywordBoard,
    filterState,
    setFilterState,
    modalImport,
    setModalImport,
    text,
    setText,
    // REVAMP
    datasOkr,
    setDatasOkr,
    okrId,
    setOkrId,
    isLoading,
    setIsLoading,
    boardSw,
    setBoardSw,
    showInfoComp,
    setShowInfoComp,
    showInquiryComp,
    setShowInquiryComp,
    dataInfoComp,
    setDataInfoComp,
    isDetailJobDesc,
    setIsDetailJobDesc,
  };

  return <Hooks.Provider value={valx}>{props.children}</Hooks.Provider>;
}

export default Index;
